// extracted by mini-css-extract-plugin
module.exports = {"Instance":"Instance_Instance__3zTCW","Messages":"Instance_Messages__hVdnd"};